import { all } from 'redux-saga/effects';

import userSagas from './user/sagas';
import restaurantsSaga from './restaurant/sagas';
import companySaga from './company/sagas';
import commonSaga from './common/sagas';
import ownerSaga from './owner/sagas';
import dishesSaga from './dishes/sagas';
import dishCategoriesSaga from './dishes_categories/sagas';
import dishOptionsSaga from './dishes_options/sagas';
import settingsSagas from './settings/sagas';
import specialMenuSaga from './special_menu/sagas';

export default function* rootSaga() {
  yield all([
    userSagas(),
    restaurantsSaga(),
    companySaga(),
    ownerSaga(),
    commonSaga(),
    dishesSaga(),
    dishCategoriesSaga(),
    dishOptionsSaga(),
    settingsSagas(),
    specialMenuSaga(),
  ]);
}
